import React from 'react';

interface OcrConfidenceBadgeProps {
  confidence: number; // 0-1
  className?: string;
}

const OcrConfidenceBadge: React.FC<OcrConfidenceBadgeProps> = ({ confidence, className = '' }) => {
  if (confidence < 0.5) return null;

  const pct = Math.round(confidence * 100);
  const isHigh = confidence >= 0.8;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${
        isHigh
          ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
          : 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
      } ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${isHigh ? 'bg-green-500' : 'bg-amber-500'}`} />
      {pct}%
    </span>
  );
};

export default OcrConfidenceBadge;
